module.exports = __webpack_public_path__ + "img/left-arrow-disabled.81b82ab0.svg";